<template>
	<div>
		<c-dialog ref="dialog" :title="'【' + username + '】的发票信息'" width="1000" :button="selector" :cancel-button="false">
			<m-search @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="发票抬头" name="invoice_title"></c-form-item>
					<c-form-item type="input" label="发票税号" name="tax_number"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_platform_user_invoice_edit" icon="add" color="sys" @click="editHandle()">新增</c-button>
			</m-operate>

			<c-table ref="list" height="400" :paging="false">
				<c-table-column
					v-if="selector"
					type="selector"
					:multiple="false"
				></c-table-column>
				
				<c-table-column
					label="发票类型"
					name="invoice_type"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="data.invoice_type == 1">普通发票</span>
						<span v-else-if="data.invoice_type == 2">增值税专用发票6%</span>
						<span v-else-if="data.invoice_type == 3">增值税专用发票13%</span>
					</template>
				</c-table-column>

				<c-table-column
					label="发票抬头"
					name="invoice_title"
					width="160"
				></c-table-column>

				<c-table-column
					label="税号"
					name="tax_number"
					width="160"
				></c-table-column>

				<c-table-column
					label="开户行"
					name="bank_name"
					width="110"
				></c-table-column>
				
				<!-- <c-table-column
					label="银行账户"
					name="bank_account"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="开票地址"
					name="kp_address"
					width="150"
				>
				</c-table-column>
				
				<c-table-column
					label="开票电话"
					name="kp_phone"
					width="130"
				>
				</c-table-column> -->

				<!-- <c-table-column
					label="收票联系人"
					name="contact_name"
					width="85"
				>
				</c-table-column> -->

				<c-table-column
					label="默认"
					name="is_default"
					width="50"
				>
					<template v-slot="{data}">
						{{data.is_default == 1 ? '否' : '是'}}
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button power="b_platform_user_invoice_edit" @click="editHandle(data)">编辑</c-table-button>
						<c-table-button power="b_platform_user_invoice_edit" @click="deleteHandle(data)">删除</c-table-button>
						<c-table-button power="b_platform_user_invoice_edit" v-if="data.is_default == 1"  @click="defaultHandle(data)">设为默认</c-table-button>
					</template>
				</c-table-column>

			</c-table>

			<template v-if="selector" slot="button">
				<c-button size="m" @click="resolveHandle">确定</c-button>
			</template>
		</c-dialog>

		<c-dialog ref="edit" :title="editFlag ? '编辑发票信息':'新增发票信息'" width="550" height="550" @resolve="editSubmit">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item  type="radio" label="发票类型" name="invoice_type" v-model="invoiceTypeVal" :options="invoiceType" required></c-form-item>
				<c-form-item type="input" label="发票抬头" name="invoice_title" required></c-form-item>
				<c-form-item type="input" label="纳税识别号" name="tax_number" required></c-form-item>
				<c-form-item type="input" v-show="invoiceTypeVal != 1" label="开户银行" name="bank_name" required></c-form-item>
				<c-form-item type="input" v-show="invoiceTypeVal != 1" label="银行账户" name="bank_account" required></c-form-item>
				<c-form-item type="input" v-show="invoiceTypeVal != 1" label="开票地址" name="kp_address" required></c-form-item>
				<c-form-item type="input" v-show="invoiceTypeVal != 1" label="开票电话" name="kp_phone" required></c-form-item>
				<c-form-item type="input" label="收票联系人" name="contact_name" ></c-form-item>
				<c-form-item type="input" label="收票人电话" name="contact_phone" ></c-form-item>
				<c-form-item type="region" label="收票地址" province-name="company_address_province" city-name="company_address_city" county-name="company_address_county" address-name="company_address_deails" ></c-form-item>
				<c-form-item type="input" label="电子邮箱" name="email" ></c-form-item>
				<c-form-item type="checkbox" name="is_default" :options="defaultType"></c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			selector: Boolean
		},
		
		data() {
			return {
                invoiceTypeVal: '',
				username: '',
				userId: '',
				invoiceType: [{
					name: '普通发票',
					value: 1
				}, {
					name: '增值税专用发票6%',
					value: 2
				}, {
					name: '增值税专用发票13%',
					value: 3 
				}],
				defaultType: [{
					name: '设为默认',
					value: '2'
				}],
				editFlag: false
			}
		},

		methods: {
			open(data) {
				this.username = data.nick_name;
				this.userId = data.platform_user_id;
				this.$refs.dialog.open();
				this.searchHandle();
			},

			searchHandle(data = {}) {
				this.$refs.list.load({
					url: '/member_user/invoice/list',
					data : Object.assign(data, {
                        platform_user_id: this.userId
					})
				});
			},

			editHandle(data) {
				this.editFlag = !!data;
				this.$refs.editForm.clear();
				this.$refs.edit.open();
				
				if (data) {
					this.request({
						url: '/member_user/invoice/detail',
						data: {
                            platform_user_id:this.userId,
							id: data.id
						},
						loading: true,
						success: data => {
                            data.is_default = [data.is_default];
							this.$refs.editForm.set(data);
						}
					});
				}else{
                    this.$refs.editForm.set({invoice_type:1});
                }
			},

			editSubmit(stop) {
				stop();
				this.$refs.editForm.submit({
					url: this.editFlag ? '/user_invoice/edit':'/user_invoice/add',
					rule: {
						invoice_type: '请选择发票类型',
						invoice_title: '请填写发票抬头',
						tax_number: '请填写纳税识别号',
						bank_name:[{
							type:'empty',
							skip: () => {
								return this.invoiceTypeVal == 1;
							},
							word: '请填写开户银行'
						}],
						bank_account:[{
							type:'empty',
							skip: () => {
								return this.invoiceTypeVal == 1;
							},
							word: '请填写银行账户'
						}],
						kp_address:[{
							type:'empty',
							skip: () => {
								return this.invoiceTypeVal == 1;
							},
							word: '请填写开票地址'
						}],
						kp_phone:[{
							type:'empty',
							skip: () => {
								return this.invoiceTypeVal == 1;
							},
							word: '请填写开票电话'
						}]
					},
					dataFormatter: data => {
						data.user_id = this.userId;
                        data.is_default = data.is_default.toString();
						return data;
					},
					success: (data, res) => {
						this.$message({
							text: '添加成功'
						});
						this.$refs.list.update();
						this.$refs.edit.close();
					}
				});
			},

			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除此发票吗？',
					resolve: () => {
						this.request({
							url: '/user_invoice/del',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.list.update();
							}
						});
					}
				});
			},

			defaultHandle(data) {
				this.$confirm({
					text: '确定将此发票设为默认发票吗？',
					resolve: () => {
						this.request({
							url: '/user_invoice/edit_state',
							data: {
								id: data.id,
							},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.list.update();
							}
						});
					}
				});
			},
			
			resolveHandle() {
				let row = this.$refs.list.getRow('selected')[0];
				if (!row) {
					this.$message({
						text: '请选择发票'
					});
					return;
				}
				this.$emit('resolve', row.data);
				this.$refs.dialog.close();
			}
		}
	}
</script>